import React from "react";
import "./BackButton.css";

interface Props {
  onClick: () => void;
  /** Destination label, e.g. "Sections" → renders "← Sections". */
  label?: string;
}

/** Token-themed "← Back" button used inside the app's content areas (distinct
 *  from the global nav back-btn). */
const BackButton: React.FC<Props> = ({ onClick, label }) => (
  <button type="button" className="back-button" onClick={onClick}>
    ← {label ?? "Back"}
  </button>
);

export default BackButton;
